export default "__VITE_ASSET__D_r3Hr$P__"